enum CommandShortcutOrigin {
  ChatWindow,
  SearchBar
}

interface ICommandShortcutContext {
  sinBinUser(username: string): Promise<void>;
  banUser(username: string): Promise<void>;
  awardChatPrize(usernames: string[]): Promise<void>;
  readonly commandOrigin: CommandShortcutOrigin;
}

interface IChatWindowCommandShortcutContext extends ICommandShortcutContext {
  toggleUserListSortOrder(): void;
}

interface ICommandShortcutHandler {
  canProcessCommand(command: string, context: ICommandShortcutContext): boolean;
  processCommand(command: string, context: ICommandShortcutContext): void;
}

interface ICommandShortcutHandlerProvider {
  getAllHandlers(): ICommandShortcutHandler[];
}

interface ICommandShortcutService {
  processCommand(command: string, context: ICommandShortcutContext): boolean;
}

export { CommandShortcutOrigin, ICommandShortcutHandler, ICommandShortcutHandlerProvider, ICommandShortcutService, ICommandShortcutContext, IChatWindowCommandShortcutContext };



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./src/components/chat/_domain/modules/command-shortcut-service/command-shortcut-service-interface.ts